import React, { useState } from 'react';
import { RegisterCompanyManager, SignUp } from './components';
import { Switch } from 'react-router-dom';
import { useAuthFunctions } from 'contexts/AuthContext';
import routes from 'config/routes';

const RegisterHandler = () => {
    const [pwd, setPwd] = useState("");
    const [oauth, setOauth] = useState(false);
    const [stepNb, setStepNb] = useState(0);

    const { signUp } = useAuthFunctions();

    function setPassword(psw) {
        if (oauth === false)
            setPwd(psw);
    }

    function registerWithGoogle() {
        setOauth(true)
        setStepNb(1);
    }
    async function createAccount(email, firstName, lastName) {
        if (oauth === true) return;
        await signUp({ email, firstName, lastName, password: pwd });
    }
    return (
        <Switch>
            <SignUp path={routes.signup.root} setPwd={setPassword} setOauth={registerWithGoogle} pwd={pwd} setStepNb={setStepNb} stepNb={stepNb} oauth={oauth}/>
            <RegisterCompanyManager path={routes.register.company.root} createAccount={createAccount} setStepNb={setStepNb}/>
        </Switch>
    )
}

export default RegisterHandler;
